import React from 'react'

import { Link } from "react-router-dom";

import "./Experiments.scss"

const BaseURL = "https://pedromelgueira.com"

const ExperimentsContent = [{
  "title": "Dissecting Redis Attacks",
  "description": "Catching malicious IPs, URLs and Samples.",
  "link": "dissecting_redis_attacks_with_honeyshare",
}, {
  "title": "Analysing a blacklisted hostname",
  "description": "Decoded payloads and reverse DNS'ing.",
  "link": "analysing_a_hostname_blacklisted_by_honeyshare",
}, {
  "title": "Analysing Dropped Samples",
  "description": "Finding out what attackers are dropping into vulnerable SSH servers.",
  "link": "analysing_dropped_samples_in_honeyshares_ssh_honeypots",
}, {
  "title": "Data Extortion PCAPs Analysis",
  "description": "Using HoneyShare PCAP analysis we see a data extortion attack unfolding and to get data points such as bitcoin addressed.",
  "link": "pcap_analysis_of_mysql_data_extortion_attacks_in_honeyshare",
}];

function Experiments() {
  function makeCard(exp) {
    return (
      <div className="column is-one-third">
        <a href={BaseURL + "/" + exp["link"]} target="_blank">
          <div className="card honey-experiments-card">
            <header className="card-header">
              <p className="card-header-title">{exp["title"]}</p>
            </header>
            <div className="card-content honey-licenses-card-content">
              <div className="content">
                {exp["description"]}
              </div>
            </div>
          </div>
        </a>
      </div>
    )
  }

  let chunk_size = 3;
  let exp_rows = [];

  for (let i = 0; i < ExperimentsContent.length; i += chunk_size) {
    exp_rows.push(ExperimentsContent.slice(i, i + chunk_size));
  }

  console.log(exp_rows);

  return (
    <div className="container block is-max-desktop">
      <div className="container block">
        <h3 className="has-text-weight-bold is-size-3 honey-text-font-family-common honey-text-common">
          Experiments
        </h3>
      </div>
      {exp_rows.map((row) => (
        <div className="columns">
          {row.map((exp) => (
            makeCard(exp)
          ))}
        </div>
      ))}
    </div>
  );
}

export default Experiments;
